export enum StatoEvento {
    INFO = 1,
    WARNING = 2,
    ERROR = 3,
  }